import axios from 'axios'
import store from '@/store'
import JSONbig from 'json-bigint'
import { refreshSession } from '@/api/user'
import http from '@/utils/http'
import { Toast } from 'vant'

let basePath
if (process.env.VUE_APP_BASE_ENV === 'dev') {
  basePath = 'http://www.iwuyu.cn/'
} else {
  basePath = 'https://cpj.zuiqipei.com/'
}
const instance = axios.create({
  baseURL: basePath,
  timeout: 1000 * 60 * 5,
  withCredentials: true,
  transformResponse: [function (data) {
    try {
      return JSONbig.parse(data)
    } catch (err) {
      // 如果解析不了, 说明不是json格式, 原样输出
      return data
    }
  }]
})

// 添加请求拦截器
instance.interceptors.request.use(function (config) {
  const token = store.state.user.token
  if (config.method === 'post') {
    if(!config.data) config.data = {}
    if(token && !config.pass && !config.url.includes('refreshSession')) config.data.sid = token
  } else if (config.method === 'get') {
    if (!config.params) config.params = {}
    if(token) config.params.sid = token
  }
  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})

// 添加响应拦截器
instance.interceptors.response.use(
  // 响应成功
  async function (response) {
    const { config, data } = response
    // token过期, 刷新token并重新发送请求 实现无感刷新
    if(response.data.state === 4) {
      const token = store.state.user.token
      const { key } = store.state.user.queryInfo || {}
      const {success, model} = await refreshSession({ phoenix_sid: token, mall_token: key })
      if(success) {
        const refresh_token = model.phoenix_sid
        store.commit('user/setTokenInfo', refresh_token)
        const newData = JSON.parse(config.data)
        newData.sid = refresh_token
        config.data = JSON.stringify(newData)
        config.pass = true
        return http(config)
      } else {
        // 获取新token失败，重新登录
        localStorage.clear()
        store.commit('user/removeUserInfo')
        store.dispatch('user/getUserInfo', () => {
          const token = store.state.user.token
          const newData = JSON.parse(config.data)
          newData.sid = token
          config.data = JSON.stringify(newData)
          return http(config)
        })
      }
    }
    // 对响应数据做点什么
    return data
  },
  // 响应失败
  async function (error) {
    // 对响应错误做点什么
    Toast('出错了，请稍候重试')
    return Promise.reject(error)
  })

export default instance